import { NodeSubType, NodeType } from "../../app.types";
import { chatBotIcon, analysisToolIcon } from "../../svgs";
import {
  CoreNodesCircleIconStyled,
  LetterIconMapping,
} from "./corenodetypescircleicon.styles";
import { CoreNodesCircleIconProps } from "./corenodetypescircleicon.types";

function CoreNodesCircleIcon(props: CoreNodesCircleIconProps): JSX.Element {
  const {
    nodeType,
    nodeSubType,
    isSelected,
    width = "25px",
    height = "25px",
  } = props;

  const nodeTypeToLetterMapping: {
    [key in NodeType]?: { letter: string | JSX.Element; title: string };
  } = {
    TBL: { letter: "T", title: "Database Table" },
    DSR: { title: "BI Model", letter: "DS" },
    COL: { letter: "C", title: "Database Column" },
    TRM: { letter: "G", title: "Glossary Term" },
    DSF: { letter: "DSF", title: "BI Source Field" },
    ANL: {
      letter: chatBotIcon(width, height),
      title: "Agent",
    },
    RLS: { letter: "DQ", title: "DQ Rule" },
    JOB: { letter: "J", title: "Job" },
    LIN: { letter: "L", title: "Lineage" },
    PLO: { letter: "ETL", title: "ETL Program" },
    DTB: { letter: "DB", title: "Database" },
    WSP: { letter: "W", title: "Workspace" },
    SCM: { letter: "S", title: "Database Schema" },
    RFD: { letter: "RD", title: "Reference Dictionary" },
    DMN: { letter: "DM", title: "Data Domain" },
    POF: { letter: "ET", title: "ETL Transformation" },
    CAT: { letter: "SD", title: "Sub Domain" },
  };

  const nodeSubTypeToLetterMapping: {
    [key in NodeSubType | string]?: {
      letter: string | JSX.Element;
      title: string;
    };
  } = {
    RPT: { letter: "R", title: "BI Report" },
    VIW: { letter: "V", title: "View" },
    TOL: { letter: analysisToolIcon("25", "25"), title: "Tool" },
  };

  const mappedInfo =
    nodeSubTypeToLetterMapping?.[nodeSubType || ""] ||
    nodeTypeToLetterMapping?.[nodeType];

  const isSvgIcon = false;
  const showBackgroundColor = nodeType !== "ANL";

  return (
    <CoreNodesCircleIconStyled
      {...props}
      title={mappedInfo?.title || ""}
      className="core-nodes-circle-icon"
      data-testid="core-nodes-circle-icon-main-wrapper"
      showBackgroundColor={showBackgroundColor}
    >
      <LetterIconMapping
        isSvg={isSvgIcon}
        className="letter-icon-mapping"
        data-testid="core-nodes-circle-icon-letter-mapping"
        isSelected={isSelected}
      >
        {mappedInfo?.letter}
      </LetterIconMapping>
    </CoreNodesCircleIconStyled>
  );
}

export default CoreNodesCircleIcon;
